var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPpsx64 = function SvgPpsx64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 2048 2048"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1719 544q9 11 9 23v1321q0 14-9 23t-23 9H608v-32h1088V576h-384q-14 0-23-9t-9-23V160H384v288h-32V160q0-14 9-23t23-9h905q14 0 23 9m361 407-361-361v361M749 1711l-173-172v509h-32v-509l-173 172-24-23 213-213 213 213M544 960H256q-14 0-23-9t-9-23V512h-96v-32h864v32h-96v416q0 14-9 23t-23 9H576v288h160v32H384v-32h160m320-320V512H256v416z",
    className: "ppsx_64_svg__OfficeIconColors_HighContrast"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M1707 555q5 5 5 12v1321q0 16-16 16H608v-272l140 146 94-89-234-234v-143h160v-96H608V992h256q26 0 45-19t19-45V544h96v-96H368V160q0-16 16-16h905q7 0 12 5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#797774",
    d: "M1719 544q9 11 9 23v1321q0 14-9 23t-23 9H608v-32h1088V576h-384q-14 0-23-9t-9-23V160H384v288h-32V160q0-14 9-23t23-9h905q14 0 23 9m361 407-361-361v361z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8F6B",
    d: "M880 496v448H240V496z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.498,
    d: "M880 496v448H240V496z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D35230",
    d: "M992 480v32h-96v416q0 14-9 23t-23 9H576v288h160v32H384v-32h160V960H256q-13 0-22-9-10-9-10-23V512h-96v-32m736 32H256v416h608z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED6C47",
    d: "M544 2048v-509l-173 172-24-23 213-213 213 213-24 23-173-172v509z"
  })));
};
export default SvgPpsx64;